import React, { Component } from 'react';

const getRemaining = (value, max) => value && max ? `${value.length}/${max}` : null;

export default function withLimitCounter(WrappedTextArea) {
    return class LimitCounter extends Component {
        render() {
            const { input: { value }, maxLength } = this.props;

            return (
                <div className='with-limit-counter'>
                    <WrappedTextArea {...this.props} />
                    <div className="limit-show">{ getRemaining(value, maxLength) }</div>
                </div>
            );
        }
    }
}
